import PastVisitsList from 'components/Dashboard/Main/PastVisits/PastVisitsList'
import withFeatureFlagToggle from '../withFeatureFlagToggle'
import PastVisitsListOld from 'components/Dashboard/Main/PastVisits/PastVisitsListOld'
import PastVisitsCollection from 'models/Provider/PastVisitsCollection'
import { ReactNode } from 'react'

export const PastVisitsListToggle = withFeatureFlagToggle<{ list: PastVisitsCollection['list']; header?: ReactNode }>(
  'pwMedicationSafetyPhase2',
)(PastVisitsList, PastVisitsListOld)
